import { render, staticRenderFns } from "./CaseMergeModal.vue?vue&type=template&id=4e1bb7ba&scoped=true&"
import script from "./CaseMergeModal.vue?vue&type=script&lang=ts&"
export * from "./CaseMergeModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1bb7ba",
  null
  
)

export default component.exports